<template>
    <div class="gallery-image" :class="bemFacet">
        <!-- <pre v-if="content" v-text="content"></pre> -->
        <button type="button" class="u-reset gallery-image--btn"
                :disabled="hasClickListener ? null : true"
                @click.prevent="onImageClicked">
            <span class="gallery-image--wrap">
                <img class="gallery-image--image-accessor" :src="preloadGuardedSrc" :alt="resource.alt">
            </span>
        </button>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import bemMixin from 'vue/mixins/bem';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';


    export default {
        mixins: [
            bemMixin('gallery-image'),
            cmsPlugin,
        ],
        props: {
            preload: Boolean,
            resourceName: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                allowImageLoad: false,
            };
        },
        computed: {
            resource() {
                return get(this, `content[${ this.resourceName }]`, {});
            },
            preloadGuardedSrc() {
                return this.allowImageLoad ? this.resource.url : '';
            },
            hasClickListener() {
                return (this.$listeners && !!this.$listeners['image-clicked']);
            },
        },
        methods: {
            onImageClicked() {
                this.$emit('image-clicked');
            },
        },
        watch: {
            preload: {
                handler(val) {
                    if (this.allowImageLoad || !val) {
                        return;
                    }

                    this.allowImageLoad = true;
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2b7bc2d4